module.exports = __webpack_public_path__ + "img/ic_delete_wh.d325c718.svg";